// Today's Deals — UI constants + adapter re-exports.
//
// Products come from GET /e-commerce/catalog/deals (Redux ecomCatalog.deals) as
// CatalogProduct and are mapped to card props with the same adapter the
// CategoryListingPage uses, so pricing/rating/delivery/deal badges are
// consistent across listing surfaces.
import { EcomDealType } from "../../../Redux/ecomCatalog/types";

export {
  mapCatalogProductToCard,
  formatPrice,
  type CategoryCardData,
} from "../CategoryListingPage/CategoryListingTypes";

/** Tab strip — mirrors DealsPage's CATALOG_TAB_DEAL_TYPE mapping. */
export type DealTabId = "todayDeals" | "limitedDeals" | "coupons" | "comboOffers" | "bogo";

export const DEAL_TABS: { id: DealTabId; label: string; dealType?: EcomDealType }[] = [
  { id: "todayDeals", label: "All Deals" }, // any currently active offer
  { id: "limitedDeals", label: "Limited Time Deals", dealType: EcomDealType.DEAL },
  { id: "coupons", label: "Coupons", dealType: EcomDealType.COUPON },
  { id: "comboOffers", label: "Combo Offers", dealType: EcomDealType.PROMOTION },
  { id: "bogo", label: "Buy 1 Get 1", dealType: EcomDealType.BOGO },
];

export type DealSort =
  | "discount"
  | "ending_soon"
  | "rating"
  | "price_asc"
  | "price_desc"
  | "newest";

export const SORT_OPTIONS: { value: DealSort; label: string }[] = [
  { value: "discount", label: "Discount: High to Low" },
  { value: "ending_soon", label: "Ending Soon" },
  { value: "rating", label: "Customer Rating" },
  { value: "price_asc", label: "Price: Low to High" },
  { value: "price_desc", label: "Price: High to Low" },
  { value: "newest", label: "Newest" },
];
